import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLanguage } from '../LanguageContext';
import '../styles/scss/BookingButton.scss'
import { fetchData } from '../utils/api';
import { apiUrl } from '../config';
import Protected from './system/Protected';

const BookingButton = () => {
  const [st, setSt] = useState(0);
  const [mode, setMode] = useState('dates'); // Режим: "days" или "dates"
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [checkInDate, setCheckInDate] = useState("");
  const [checkOutDate, setCheckOutDate] = useState("");
  const [checkOutMin, setCheckOutMin] = useState("");
  const [checkOutMax, setCheckOutMax] = useState("");
  const [token, setToken] = useState(localStorage.getItem('accessToken') || '');
  const [role, setRole] = useState(localStorage.getItem('asd') || '');

  const [minDateBooking, setMinDateBooking] = useState("");
  const [maxDateBooking, setMaxDateBooking] = useState("");
  const [maxDaysBookingPeriod, setMaxDaysBookingPeriod] = useState("");

  const location = useLocation();
  const navigate = useNavigate();
  const { language } = useLanguage();

  useEffect(() => {
    const getDatesTrue = async () => {
      const token = localStorage.getItem('accessToken');
      if (!token) return;

      // Добавляем timestamp, чтобы избежать кэша браузера
      const result = await fetchData(
        `${apiUrl}/api/grad?t=${Date.now()}`,
        "GET",
        token,
        { cache: false }
      );

      if (result?.request?.status === 0) {
        setSt(result.request.data.st);
        setMinDateBooking(result.request.data.minDateBooking);
        setMaxDateBooking(result.request.data.maxDateBooking);
        setMaxDaysBookingPeriod(result.request.data.maxDaysBookingPeriod);
      }
    };

    getDatesTrue();

    // ... остальной код с message
  }, [location, navigate]);

  const calculateCheckOutRange = (checkIn) => {
    const selectedCheckIn = new Date(checkIn);
    const minCheckOut = new Date(selectedCheckIn.getTime() + 1 * 24 * 60 * 60 * 1000); // Минимум 1 день после заезда
    const maxCheckOut = new Date(maxDateBooking);

    return {
      minCheckOut: minCheckOut.toISOString().split("T")[0],
      maxCheckOut: maxCheckOut.toISOString().split("T")[0],
    };
  };
  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === 'cin') {
      setCheckInDate(value);
      const { minCheckOut, maxCheckOut } = calculateCheckOutRange(value);
      setCheckOutMin(minCheckOut);
      setCheckOutMax(maxCheckOut);

      if (checkOutDate && (checkOutDate < minCheckOut || checkOutDate > maxCheckOut)) {
        setCheckOutDate('');
      }
    } else if (name === 'cout') {
      const selectedCheckOut = new Date(value);
      const selectedCheckIn = new Date(checkInDate);
      const sevenDaysLater = new Date(selectedCheckIn.getTime() + maxDaysBookingPeriod * 24 * 60 * 60 * 1000);

      // Если выбранная дата выезда превышает 7 дней после даты заезда, установить ее на 7 дней после даты заезда
      if (selectedCheckOut > sevenDaysLater) {
        if (language === 'ru') {
          alert(`Максимум ${maxDaysBookingPeriod} дней`)
        } else if (language === 'tm') {
          alert(`Iň ýokary möhlet ${maxDaysBookingPeriod} gün`)
        } else if (language === 'en') {
          alert(`Maximum period ${maxDaysBookingPeriod} days`)
        }
        // setCheckOutDate(sevenDaysLater.toISOString().split("T")[0]);
      } else {
        setCheckOutDate(value);
      }
    }
  };



  const handleSearch = async (event) => {

    event.preventDefault();
    if (checkInDate && checkOutDate) {
      const token = localStorage.getItem('accessToken');
      if (!token) {
        return;
      }
      const result = await fetchData(`${apiUrl}/api/${language}/search-rooms`, "POST", token, { cache: false, body: { "checkIn": checkInDate, "checkOut": checkOutDate } })
      if (result?.request?.status === 0) {
        result.request.data.checkIn = checkInDate
        result.request.data.checkOut = checkOutDate
      }
      // Если уже на странице результатов
      if (location.pathname === "/book-rooms") {
        // Обновляем данные через состояние
        navigate("/book-rooms", { replace: true, state: { searchResults: result } });
      } else {
        // Переход на страницу результатов
        navigate("/book-rooms", { state: { searchResults: result } });
      }
    }
  };

  const buttonText = st === 1
    ? {
      ru: "Найти свободный номер",
      tm: "Açyk otag tapmak",
      en: "Find an unoccupied room",
    }[language]
    : {
      ru: "На данный момент ведутся технические работы",
      tm: "Häzirki wagtda tehniki işler alnyp barylýar",
      en: "Technical work is in progress",
    }[language];

  const langs = {
    ru: {
      check_dates: "Выберите даты",
      check_in: "Бронь с",
      check_out: "Бронь до",
      registration: "Вход",
    },
    tm: {
      check_dates: "Senesi saýlaň",
      check_in: "Giriş sene",
      check_out: "Çykyş sene",
      registration: "Giriş",
    },
    en: {
      check_dates: "Select dates",
      check_in: "Check-in from",
      check_out: "Check-out until",
      registration: "Log in",
    },
  };

  const toggleForm = () => {
    if (st === 1) {
      if (token && role === 'client') {
        setIsFormVisible(!isFormVisible) // Если всё ок, открываем форму
      } else {
        window.location.href = '/authorization'; // Если не авторизован, перенаправляем
      }
    }
  };
  return (
    <div className="booking-container">
      {role === 'client' && token ? (
        <button className={`${st === 1 ? 'booking-button' : 'booking-button-disabled'}`} onClick={toggleForm}>
          {buttonText}
        </button>
      ) : (
        <a className="booking-button" href='/authorization'>{langs[language].registration}</a>
      )}
      {isFormVisible && (
        <Protected element={
          <div className="booking-form">
            <h3>{langs[language].check_dates}</h3>
            <form onSubmit={handleSearch}>
              <label htmlFor="cin">
                {langs[language].check_in}:
                <input
                  type="date"
                  id="cin"
                  name="cin"
                  value={checkInDate}
                  min={new Date(minDateBooking).toISOString().split("T")[0]}
                  max={new Date(maxDateBooking).toISOString().split("T")[0]}
                  onChange={handleChange}
                  required
                />
              </label>
              <label htmlFor="cout">
                {langs[language].check_out}:
                <input
                  type="date"
                  id="cout"
                  name="cout"
                  value={checkOutDate}
                  min={checkOutMin}
                  max={checkOutMax}
                  onChange={handleChange}
                  required
                />
              </label>
              <button type="submit">{buttonText}</button>
            </form>
          </div>
        } requiredRoles={['client']} url='/authorization' />
      )}
    </div>
  );
};

export default BookingButton;